/**
 * Streaming status enumeration
 */
export enum StreamingStatus {
  IDLE = 'idle',
  CONNECTING = 'connecting',
  STREAMING = 'streaming',
  COMPLETED = 'completed',
  ERROR = 'error',
}

/**
 * Trace event types - these values match what the backend sends
 * Backend processes AgentCore traces and sends simplified event types
 */
export enum TraceEventType {
  USER_MESSAGE = 'user_message',
  RATIONALE = 'rationale',
  MODEL_INVOCATION_INPUT = 'model_invocation_input',
  MODEL_INVOCATION_OUTPUT = 'model_invocation_output',
  CODE_INTERPRETER = 'code_interpreter',
  CODE_INTERPRETER_OUTPUT = 'code_interpreter_output',
  CODE_INTERPRETER_ERROR = 'code_interpreter_error',
  ATHENA_QUERY_RETRY = 'athena_query_retry',
  SUMMARIZATION_START = 'summarization_start',
  SUMMARIZATION_END = 'summarization_end',
  REHYDRATION = 'rehydration',
  FINAL_RESPONSE_OBSERVATION = 'final_response_observation',
  FINAL_RESPONSE = 'final_response',
  DEFAULT = 'default',
}

/**
 * Error types for better error handling
 */
export enum ErrorType {
  CANCELED = 'canceled',
  TIMEOUT = 'timeout',
  NETWORK = 'network',
  VALIDATION = 'validation',
  UNKNOWN = 'unknown',
}
